import React, { Fragment, useState } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { enhance } from '../enhance';
import Button from '../../../Button';
import PharmacyPopup from '../PharmacyPopup';
import { makePharmacyTitle } from '../../../../utils/makePharmacyTitle';
import { appointmentProgressActions } from '../../../../redux/appointmentForm/progress-types';

import styles from './styles.styl';

function PharmacyContent({
  user,
  updateData,
  clearPharmacyList,
  intl: { formatMessage },
}) {
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [pharmacy, setPharmacy] = useState(null);
  const { primaryPatientProfile } = user;

  const pharmacyId = get(user, 'primaryPatientProfile.pharmacy.id');

  const togglePopupHandle = () => {
    setIsOpen(current => !current);
    clearPharmacyList();
  };

  const handleNext = () => {
    if (pharmacyId) {
      updateData();
    } else {
      dispatch(appointmentProgressActions.determineNextStepAfterPharmacy());
    }
  };

  return (
    <Fragment>
      <div className={styles.location}>
        {formatMessage({ id: 'appointments.form.pharmacyLocation' })}
      </div>
      <div className={styles.address}>
        {primaryPatientProfile &&
          makePharmacyTitle(pharmacy || primaryPatientProfile.pharmacy, true)}
      </div>
      <div className={styles.buttonsBlock}>
        <div>
          <Button
            raised
            color="accent"
            className="mr2"
            onClick={togglePopupHandle}
          >
            {formatMessage({ id: 'appointments.form.changePharmacy' })}
          </Button>
          <Button raised disabled color="accent" className={styles.hide}>
            {formatMessage({ id: 'appointments.form.selectFromMap' })}
          </Button>
        </div>
        <Button raised color="primary" onClick={handleNext}>
          {formatMessage({ id: 'common.next' })}
        </Button>
      </div>
      {isOpen && (
        <PharmacyPopup
          isOpen={isOpen}
          onClose={togglePopupHandle}
          setPharmacy={setPharmacy}
        />
      )}
    </Fragment>
  );
}

PharmacyContent.propTypes = {
  user: PropTypes.object,
  intl: PropTypes.object,
  updateData: PropTypes.func,
  clearPharmacyList: PropTypes.func,
};

export default enhance(PharmacyContent);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentPharmacy/PharmacyContent/index.jsx